import type { FunctionComponent, PropsWithChildren } from 'react';
import { Navigate } from 'react-router';

import { useApplicationContext } from '~/shared/context/use-application-context';
import type { FeatureName } from '~/shared/feature-flag-service/feature-flag-service';

export type DataRouteWithFeatureFlagEnabledProperties = {
    /** The flag the route needs, or several flags that must all be enabled. */
    readonly enabledFeatureName: FeatureName | readonly FeatureName[];
};

// The data router builds its routes outside ApplicationContext, so unlike
// PageWithFeatureFlagEnabled this reads the flag service from context and sends
// a direct URL hit back to the start page instead of rendering nothing.
export const DataRouteWithFeatureFlagEnabled: FunctionComponent<
    PropsWithChildren<DataRouteWithFeatureFlagEnabledProperties>
> = ({ children, enabledFeatureName }) => {
    const { applicationState } = useApplicationContext();
    const featureNames: readonly FeatureName[] =
        typeof enabledFeatureName === 'string' ? [enabledFeatureName] : enabledFeatureName;

    if (!featureNames.every((name) => applicationState.featureFlagService.isFeatureFlagEnabled(name))) {
        return <Navigate replace={true} to="/" />;
    }

    return children;
};
